import {createAction, props} from '@ngrx/store';
import {User} from '@automata/models/user';

export const LoadUsers = createAction('[Users] Load Start');
export const LoadUsersComplete = createAction('[Users] Load Complete', props<{users: User[]}>());

export const Logout = createAction('[Users] Logout');
